export default __webpack_public_path__ + "static/media/6-shine.636c2a16.png";